import './Footer.css'

const Footer = () => {
  return (
    <div className="footer">
      <h2>Genuss hat viele Facetten..</h2>
      <p>..aber ohne das richtige Maß geht es nicht!</p>
      <p>
        
        Cocktails kann man mit allen Sinnen genießen. Zum Cocktail-Genuss
        gehören neben dem Geschmack natürlich auch die Optik, die Farbe und die
        verschiedenen Aromen, die im Zusammenspiel ganz neue Assoziationen
        wecken und unterbewusst auch den Geschmack beeinflussen.
      </p>
    </div>

  )

}

export default Footer
